import { TFunction } from "i18next";
import * as yup from "yup";
import { InferType } from "yup";
import { WEEK_DAYS } from "@/domain/externalProviders.interface";

const externalProviderValidationSchema = (t: TFunction) =>
  yup.object().shape({
    categoryId: yup.string().required("This field is required"),
    name: yup
      .string()
      .required("This field is required")
      .max(200, t("validations.max_length", { count: 200 })),
    description: yup
      .string()
      .required("This field is required")
      .max(1000, t("validations.max_length", { count: 1000 })),
    email: yup.string().email(t("validations.invalid_format")).default(""),
    website: yup.string().default(""),
    phoneNumber: yup.string().default(""),
    allowPP: yup.string().default(""),
    status: yup
      .string()
      .oneOf(["ACTIVE", "INACTIVE", ""], "Invalid status")
      .default("ACTIVE"),

    // Location (single object) — comma-separated restrictions tags
    locationName: yup.string().default(""),
    addressLine1: yup.string().default(""),
    addressLine2: yup.string().default(""),
    city: yup.string().default(""),
    state: yup.string().default(""),
    zip: yup.string().default(""),
    locationRestrictions: yup.string().default(""),

    // Service (single object)
    serviceName: yup.string().default(""),
    serviceDescription: yup.string().default(""),
    rewardsType: yup.string().default(""),
    parcaPoints: yup.string().default(""),

    languages: yup
      .array()
      .of(
        yup.object().shape({
          language: yup.string().required("Language is required"),
          description: yup.string().default(""),
          services: yup.string().default(""),
          restrictions: yup.string().default(""),
          hours: yup
            .array()
            .of(
              yup.object().shape({
                day: yup
                  .string()
                  .required("Day is required")
                  .oneOf([...WEEK_DAYS], "Invalid day"),
                hour: yup.string().required("Hour is required"),
              })
            )
            .default([]),
        })
      )
      .min(1, "Add at least one language")
      .required(),
  });

export type ExternalProviderFormData = InferType<
  ReturnType<typeof externalProviderValidationSchema>
>;

export default externalProviderValidationSchema;
